import { PreviewType } from "src/components/PlayerPreview";
import { CustomChannelPreview } from "./styles";

export const ChannelPreview = ({ channelId }: { channelId: string }) => {
  return (
    <CustomChannelPreview
      id={channelId}
      previewType={PreviewType.CHANNEL}
      showPlayerOnly={true}
      className="custom-channel-preview"
    />
  );
};
